import { Navigate, useLocation } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";

/** Redirects unauthenticated users to /auth. */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loadingAuth } = useApp();
  const location = useLocation();

  if (loadingAuth) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 rounded-full border-2 border-primary/20 border-t-primary animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={`/auth?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  return <>{children}</>;
}

/** Redirects non-admin users away from admin routes. */
export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { user, loadingAuth } = useApp();
  const location = useLocation();

  if (loadingAuth) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 rounded-full border-2 border-primary/20 border-t-primary animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={`/auth?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  if (user.role !== "admin" && user.role !== "super_admin" && user.role !== "operator") {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
